import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { SessionService } from './session.service';
import e from 'express';


@Injectable({
  providedIn: 'root'
})
export class ClientCookiesService {
  constructor(
    private cookieService: CookieService,
    private sessionService: SessionService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  collectAndUpdateCookies(sessionId: string) {
    if (isPlatformBrowser(this.platformId)) {  
      try {
        let fbp = '';
        let fbc = '';
        let jornayaLeadId = '';
        let cookies = this.cookieService.getAll();

        Object.entries(cookies).forEach((entry) => {
          const [key, value] = entry;
          if (key === '_fbp' && value.includes('fb.')) {
            fbp = value;
          }
        });

        Object.entries(cookies).forEach((entry) => {
          const [key, value] = entry;
          if (key === '_fbc' && value.includes('fb.')) {
            fbc = value;
          }
        });

        jornayaLeadId = this.cookieService.get("leadid_token-A5C265E9-8534-36A2-2FD2-91EA4C3F280B-40966533-66E8-9F6A-65DB-A6FFD7860B0D");
        let uuid = sessionId;
        //localStorage.getItem('session-uuid');

        if (uuid) {        
          this.updateSessionCookies(uuid, fbp, fbc, jornayaLeadId, cookies);          
        } else {
          console.error('Session UUID not found in local storage');
        }
      } catch (error) {
        console.error('an error occured in collectAndUpdateCookies ' + JSON.stringify(error));
      }
    }
  }

  updateSessionCookies(uuid: string, fbp: string, fbc: string, jornayaLeadId: string, cookies: any) {
    this.sessionService.updateSession(
      uuid, fbp, fbc, jornayaLeadId, cookies, document.referrer
    ).subscribe({
      next: (response) => {
       // console.log('Successfully updated session ' + uuid);
      },
      error: (error) => {
        console.error(
          'Error occurred while updating brand details:',
          error
        );
      },
    });
  }
}
